import { Button } from 'src/common/Button/Button';
import { I18n } from 'src/modules/common/components/I18n/I18n';
import { MESSAGES } from 'src/modules/common/constants';
import { AddProjectSelectionIcon } from 'src/modules/common/icons/AddProjectSelectionIcon';
import { useProjectNavigation } from 'src/projects/navigation/ProjectNavigationContext';

export const ProjectEmptySelection = () => {
    const { goHome } = useProjectNavigation();
    return (
        <div className="vss-project-empty-selection">
            <div className="vss-project-empty-selection__empty-title">
                <I18n messageId={MESSAGES.projectPageEmptyTitle}/>
            </div>

            <div className="vss-project-empty-selection__empty-description">
                <I18n messageId={MESSAGES.projectPageEmptyDescription}/>
            </div>

            <Button
                kind="primary"
                onClick={goHome}
                icon={(
                    <div className="vss-project-empty-selection__icon">
                        <AddProjectSelectionIcon/>
                    </div>
                )}
            >
                <I18n messageId={MESSAGES.projectPageHomePage}/>
            </Button>
        </div>
    );
};
